import { LOGO_URL, COMPANY } from "@/data/site";

export function Footer() {
  return (
    <footer className="border-t border-white/10 bg-[#050507]" data-testid="main-footer">
      <div className="max-w-7xl mx-auto px-5 sm:px-8 py-14 grid md:grid-cols-3 gap-10">
        <div>
          <div className="flex items-center gap-3">
            <img src={LOGO_URL} alt="AirDroneJet" className="h-9 w-auto" />
            <span className="font-heading font-extrabold tracking-tight">
              AIR<span className="fire-text">DRONE</span>JET
            </span>
          </div>
          <p className="text-sm text-slate-500 leading-relaxed mt-4 max-w-xs">
            Pulizia e manutenzione di impianti fotovoltaici con droni.
            <br />
            {COMPANY.legal} — {COMPANY.address}
          </p>
        </div>
        <div>
          <p className="font-mono-adj text-[10px] uppercase tracking-[0.3em] text-slate-500 mb-4">Navigazione</p>
          <div className="flex flex-col gap-2.5">
            {[
              ["#come-funziona", "Come Funziona"],
              ["#vantaggi", "Vantaggi"],
              ["#pacchetti", "Pacchetti"],
              ["#galleria", "Galleria"],
              ["#faq", "FAQ"],
            ].map(([href, label]) => (
              <a key={href} href={href} className="text-sm text-slate-400 hover:text-orange-400 transition-colors w-fit" data-testid={`footer-link-${label.toLowerCase().replace(/\s/g, "-")}`}>
                {label}
              </a>
            ))}
          </div>
        </div>
        <div>
          <p className="font-mono-adj text-[10px] uppercase tracking-[0.3em] text-slate-500 mb-4">Contatti</p>
          <div className="flex flex-col gap-2.5 text-sm text-slate-400">
            <span>Numero Verde: {COMPANY.phone}</span>
            <span>{COMPANY.email}</span>
            <a href="https://www.airdronejet.com" target="_blank" rel="noopener noreferrer" className="hover:text-orange-400 transition-colors w-fit" data-testid="footer-website-link">
              {COMPANY.web}
            </a>
            <a href="/privacy" className="hover:text-orange-400 transition-colors w-fit" data-testid="footer-privacy-link">
              Privacy Policy
            </a>
          </div>
        </div>
      </div>
      <div className="border-t border-white/5 py-6 text-center">
        <p className="font-mono-adj text-[10px] uppercase tracking-[0.25em] text-slate-600">
          © 2026 {COMPANY.legal} — P.IVA {COMPANY.piva} — Tutti i diritti riservati
        </p>
        <p className="font-mono-adj text-[10px] uppercase tracking-[0.25em] text-slate-600 mt-1">
          {COMPANY.brand} è un marchio di {COMPANY.legal}
        </p>
      </div>
    </footer>
  );
}
